import { OrderStatus, OrderStatusIcon, tokens, useOrderStatus } from 'ComponentLibrary'
import { Stack } from '@mui/material'
import { TextWithEllipsis } from 'ComponentLibrary/src/piazza/text'

type OrderStatusLabelProps = {
    status: OrderStatus
    size?: 'small' | 'medium'
    variant?: 'default' | 'selected'
    label?: string
}

export const OrderStatusLabel = ({ status, variant = 'default', size = 'medium', label }: OrderStatusLabelProps) => {
    const { getOrderStatusText } = useOrderStatus()
    const statusLabel = label ?? getOrderStatusText(status)

    return (
        <Stack direction="row" gap={tokens.SizingSpacing075} alignItems="center" width="fit-content" minWidth={0} maxWidth="100%">
            <OrderStatusIcon
                variant="square"
                state={status}
                size={variant === 'selected' ? tokens.SizingIconM : tokens.SizingIconS}
                label={statusLabel}
            />
            <TextWithEllipsis
                typographyProps={{ variant: SIZE_VARIANTS[size][variant], color: tokens.ColorTextBold }}
                tooltipText={statusLabel}
            >
                {statusLabel}
            </TextWithEllipsis>
        </Stack>
    )
}

const SIZE_VARIANTS: Record<
    NonNullable<OrderStatusLabelProps['size']>,
    { default: 'textS' | 'textM'; selected: 'headline3' | 'headline2' }
> = {
    medium: {
        default: 'textM',
        selected: 'headline2',
    },
    small: {
        default: 'textS',
        selected: 'headline3',
    },
}
